import type { MetricFilters } from "../../lib/dashboardWidgets";

interface FilterField {
  entity?: "agentVersions" | "agents" | "batches" | "markers";
  key: keyof MetricFilters;
  label: string;
  options?: readonly { label: string; value: string }[];
}

export const ALERT_RULE_FILTER_FIELDS: readonly FilterField[] = [
  { entity: "agents", key: "agent_id", label: "Agent" },
  {
    entity: "agentVersions",
    key: "agent_version_id",
    label: "Agent version",
  },
  { entity: "markers", key: "marker_id", label: "Marker" },
  { entity: "batches", key: "batch_id", label: "Batch" },
  {
    key: "source",
    label: "Source",
    options: [
      { label: "Live", value: "live" },
      { label: "Simulated", value: "simulated" },
    ],
  },
  {
    key: "transcript_status",
    label: "Transcript status",
    options: [
      { label: "Pending", value: "pending" },
      { label: "Processing", value: "processing" },
      { label: "Ready", value: "ready" },
      { label: "Failed", value: "failed" },
    ],
  },
  {
    key: "fail_class",
    label: "Failure class",
    options: [
      { label: "Harness failure", value: "harness_fail" },
      { label: "Agent failure", value: "agent_fail" },
    ],
  },
  {
    key: "event_type",
    label: "Usage event type",
    options: [
      { label: "Simulated minutes", value: "simulated_minutes" },
      { label: "Submitted conversation", value: "submitted_conversation" },
      { label: "Ingested voice minutes", value: "ingested_voice_minutes" },
      { label: "Ingested transcript", value: "ingested_transcript" },
      { label: "Judged evaluation", value: "judged_evaluation" },
    ],
  },
  {
    key: "modality",
    label: "Modality",
    options: [
      { label: "Voice", value: "voice" },
      { label: "Text", value: "text" },
    ],
  },
  {
    key: "transport",
    label: "Transport",
    options: [
      { label: "HTTP", value: "http" },
      { label: "WebSocket", value: "websocket" },
      { label: "Telephony", value: "telephony" },
      { label: "WebRTC", value: "webrtc" },
    ],
  },
  {
    key: "initiator",
    label: "Initiator",
    options: [
      { label: "Marker", value: "marker" },
      { label: "Agent", value: "agent" },
    ],
  },
  { key: "provider", label: "Provider" },
  { key: "name", label: "Span name" },
  {
    key: "kind",
    label: "Span kind",
    options: [
      { label: "Unspecified", value: "UNSPECIFIED" },
      { label: "Internal", value: "INTERNAL" },
      { label: "Server", value: "SERVER" },
      { label: "Client", value: "CLIENT" },
      { label: "Producer", value: "PRODUCER" },
      { label: "Consumer", value: "CONSUMER" },
    ],
  },
];
